import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'bold'
})
  /**
   * Bold pipe for making text  bold
   */
export class PipeBold implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) { }
  transform(value) {
    let text = value.trim().split(' ');
    const last = text.pop();
    text = text.join(' ') + (text.length > 0 ? '<span class="fntNormal">' + last + '</span>' : last);
    return text;
  }
}
